import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { appContext } from "../../../../AppContext";
import IbssCheckBox from "../../../../Components/Inputs/CheckBox/IbssCheckBox";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import { DateTime } from "luxon";
import { VisitDetail } from "./DataModels";

export default class VisitorStatusChecker extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    private formatDateTime(date: DateTime | null): React.ReactNode
    {
        if (!date || !date.isValid)
        {
            return "-";
        }
        return <Typography variant="body1">{date.toLocaleDateTimeString()}</Typography>;
    }

    private checkBoxList(label: string, timestamp?: DateTime): React.ReactNode
    {
        const isChecked = (
            (label === this.labels.HubLabelApproved && this.props.visitData.Visit_IsApproved === 1) ||
            (label === this.labels.HubLabelCheckedIn && this.props.visitData.Visit_IsCheckedIn === 1) ||
            (label === this.labels.HubLabelCancelled && this.props.visitData.Visit_IsCancelled === 1) ||
            (label === this.labels.HubLabelDeniedLabel && this.props.visitData.Visit_IsDenied === 1) ||
            (label === this.labels.HubLabelCheckedOut && this.props.visitData.Visit_IsCheckedOut === 1) ||
            (label === this.labels.HubLabelNoShow && this.props.visitData.Visit_IsNoShow === 1)
        );
        return (
        <>
            <Grid container alignItems={'center'}>
                <Grid item xs={5}>
                    <img
                        src="/images/readOnlyField.svg"
                        alt=""
                        width="16px"
                        height="16px"
                    />
                    <label className="form-input-box-label ml-2">
                        {label}
                    </label>
                </Grid>
                <Grid item xs={6}>
                    {this.formatDateTime(timestamp ?? null)}
                </Grid>
                <Grid item xs={1}>
                <IbssCheckBox
                    disabled
                    onClicked={() => {}}
                    checked={isChecked}
                />
                </Grid>
            </Grid>
        </>
        )        
    }

    render()
    {
        return (
            <Box my={2}>
                {this.checkBoxList(this.labels.HubLabelApproved, this.props.visitData.Visit_Approve_Time)}
                <hr className="mx-5px"/>
                {this.checkBoxList(this.labels.HubLabelCancelled)}
                <hr className="mx-5px" />
                {this.checkBoxList(this.labels.HubLabelDeniedLabel, this.props.visitData.Visit_Deny_Time)}
                <hr className="mx-5px" />
                {this.checkBoxList(this.labels.HubLabelCheckedIn, this.props.visitData.Visit_CheckIn_Time)}
                <hr className="mx-5px" />
                {this.checkBoxList(this.labels.HubLabelCheckedOut, this.props.visitData.Visit_CheckOut_Time)}
                <hr className="mx-5px" />
                {this.checkBoxList(this.labels.HubLabelNoShow)}
            </Box>
        );
    }
}

interface IProps
{
    visitData: VisitDetail;
}
interface IState
{ }